import React from "react";
import { Link } from "react-router-dom";
import { motion, useReducedMotion } from "framer-motion";
import { HandIcon } from "lucide-react";
import { StickerField } from "./StickerField";
import { CyclingGreeting } from "./CyclingGreeting";
import { BrutalButton } from "../ui/BrutalButton";
import { spring } from "../../utils/motion";
export function HomeHero() {
  const reduce = useReducedMotion() ?? false;
  return <section aria-labelledby="hero-title" className="relative flex min-h-[calc(100vh-68px)] items-center overflow-hidden px-5 py-16 md:py-20" data-id="element-826" data-mp="1s36ohwvmxg3i">
      <StickerField data-id="element-827" data-mp="1o1394x5uhrcy" />
      <motion.div initial={reduce ? false : {
      opacity: 0,
      y: 24,
      scale: 0.97
    }} animate={{
      opacity: 1,
      y: 0,
      scale: 1
    }} transition={spring.heavy} className="pointer-events-auto relative z-10 mx-auto w-full max-w-3xl rounded-panel border-3 border-line bg-surface px-5 pb-10 pt-12 text-center shadow-brutal-lg sm:px-8 md:rounded-blob md:px-14 md:pb-14 md:pt-16" data-id="element-828" data-mp="21uuc1mp2mczp">
        <h1 id="hero-title" className="text-[clamp(40px,7vw,88px)] font-bold leading-[1.1] tracking-[-0.02em] text-ink" data-id="element-829" data-mp="jzjb2vdyf55">
          Say <CyclingGreeting data-id="element-830" data-mp="5jc5dlefni6o" />
          <br data-id="element-831" data-mp="5knabojm6vzd" />
          in every language.
        </h1>
        <p className="mx-auto mt-8 max-w-[48ch] text-[17px] leading-relaxed text-ink-2 md:text-lg" data-id="element-832" data-mp="9j34cce454ma">
          60+ languages, taught from the one you already think in. Short games, a real textbook, and a translator that remembers what you look up.
        </p>
        <div className="mt-8 flex flex-col items-center justify-center gap-4 sm:flex-row" data-id="element-833" data-mp="ohf1ek5eefdz">
          <BrutalButton to="/auth/signup" size="lg" data-id="element-834" data-mp="of29be5xeon7">
            Start learning free
          </BrutalButton>
          <Link to="/pricing" className="focus-ring rounded-lg px-2 py-2 text-[15px] font-semibold text-ink underline decoration-2 underline-offset-4 hover:decoration-brand" data-id="element-835" data-mp="x9pb80cdsiup">
            See plans
          </Link>
        </div>
      </motion.div>
      <p className="pointer-events-none absolute inset-x-0 bottom-5 z-10 flex items-center justify-center gap-2 text-sm font-medium text-ink-2" data-id="element-836" data-mp="178obovmzt86m">
        <HandIcon className="h-4 w-4" strokeWidth={2.5} aria-hidden="true" data-id="element-837" data-mp="338oo0iv3n8b7" />
        Drag the words around, or tap one to hear it.
      </p>
    </section>;
}